export enum GameTypeEnum {
  LiveCasino = "LC",
  Slot = "SL",
  Sport = "SB",
  Lottery = "LT",
  Fishing = "FH",
}

export enum SubGameEnum {
  Lobby = 1,
}

export enum GameFavourite {
  ADD,
  REMOVE,
}
